"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var icon_1 = __importDefault(require("../../icon"));
// 最大支持展示数量
var MAX_CARD_LEN = 5;
/**
 * 渲染移动端头部
 */
function rendeHeader(props) {
    var firstTitle = props.firstTitle, tagTxt = props.tagTxt, firstDesc = props.firstDesc;
    return (react_1.default.createElement("div", { className: "vertical-item-header" },
        react_1.default.createElement("div", { className: "vertical-item-title" }, firstTitle),
        firstDesc ? react_1.default.createElement("div", { className: "vertical-item-left-desc" }, firstDesc) : null,
        tagTxt ? (react_1.default.createElement("div", { className: "special-tag" },
            react_1.default.createElement("span", { className: 'special-tag-txt' }, tagTxt))) : null));
}
/**
 * 渲染移动端中间部分
 */
function rendeMid(props) {
    var bigNum = props.bigNum, smallTxt = props.smallTxt, thirdDesc = props.thirdDesc, onCallback = props.onCallback, extendProps = props.extendProps, btnTxt = props.btnTxt;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "vertical-item-num" },
            react_1.default.createElement("div", { className: "num-big" }, bigNum),
            react_1.default.createElement("div", { className: "num-small" }, smallTxt)),
        react_1.default.createElement("div", { className: "vertical-item-desc" }, thirdDesc),
        react_1.default.createElement("div", { className: "vertical-item-btn" },
            react_1.default.createElement("div", __assign({ className: "vertical-item-btn-txt", onClick: function () {
                    onCallback === null || onCallback === void 0 ? void 0 : onCallback();
                } }, (extendProps || {})), btnTxt))));
}
/**
 * 渲染移动端产品列表
 */
function rendeProductList(props) {
    var _a = props.list, list = _a === void 0 ? [] : _a;
    var isThan4 = (list === null || list === void 0 ? void 0 : list.length) > 4;
    return (react_1.default.createElement("div", null, list === null || list === void 0 ? void 0 : list.map(function (item, index) {
        return rendeProductListItem(item, index, isThan4);
    })));
}
/**
 * 渲染移动端产品列表item
 */
function rendeProductListItem(item, index, isThan4) {
    var secondTitle = item.secondTitle, secondDesc = item.secondDesc;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('price-set-mobile-product', {
            'more-four': isThan4,
        }), key: index }, !isThan4 ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "vertical-product-title" }, secondTitle),
        react_1.default.createElement("div", { className: "vertical-product-desc" }, secondDesc))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "item-title-more-four" }, secondTitle),
        react_1.default.createElement("span", { className: "item-desc-more-four" }, secondDesc)))));
}
/**
 * 渲染移动端描述列表
 */
function rendeDescList(props) {
    var _a = props.descList, descList = _a === void 0 ? [] : _a;
    var newDescList = descList;
    if ((descList === null || descList === void 0 ? void 0 : descList.length) > MAX_CARD_LEN) {
        newDescList = descList.slice(0, 5);
    }
    return react_1.default.createElement("div", { className: "vertical-desc-wrap" }, newDescList === null || newDescList === void 0 ? void 0 : newDescList.map(rendeDescItem));
}
/**
 * 渲染移动端描述列表
 */
function rendeDescItem(item, index) {
    var txt = item.txt;
    return (react_1.default.createElement("div", { className: "desc-wrap-item", key: index },
        react_1.default.createElement(icon_1.default, { name: "check", size: 18, color: "#006EFF", className: "desc-icon" }),
        react_1.default.createElement("div", { className: "item-desc" }, txt)));
}
/**
 * 渲染移动端item
 */
function rendePriceSetItem(props, index, isMultiple3) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('vertical-item', {
            'three-item': isMultiple3,
        }), key: index },
        rendeHeader(props),
        rendeMid(props),
        rendeProductList(props),
        rendeDescList(props)));
}
function PriceSetMobile(props) {
    var _a = props.configuration, configuration = _a === void 0 ? [] : _a;
    var isMultiple3 = (configuration === null || configuration === void 0 ? void 0 : configuration.length) % 3 === 0;
    return (react_1.default.createElement("div", { className: "price-set-mobile" }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
        return rendePriceSetItem(item, index, isMultiple3);
    })));
}
exports.default = PriceSetMobile;
//# sourceMappingURL=PriceSetMobile.js.map